export default __webpack_public_path__ + "static/media/apostilao-matematica-natureza.92a1f3e1.jpg";